var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"geo-go"},[_c('van-loading',{attrs:{"color":"#2b5bdb"}},[_vm._v("正在跳转到专题页...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }